
import React from 'react';
import ReactDOM from 'react-dom';
import Iconify from '../../../Iconify';
import useRealNode from '../../../../hooks/useRealNode';
import { ModalPanel, Bar, CloseButton, Content } from '../../../Payments/shared/components/modals/modal-styled';

export const Modal = ({
  showModal,
  onClose,
  title = 'Solicitar Retiro',
  children,
}) => {
  const node = useRealNode('modal-node-portal');

  const handleClose = () => {
    onClose?.()
  };

  const stopPropagation = event => {
    event.stopPropagation();
  };

  if (!showModal) return null;

  return ReactDOM.createPortal(
    <ModalPanel tabIndex="1" onMouseDown={stopPropagation}>
      <Content style={{ maxWidth: 700, minHeight: 200 }}>
        <Bar>
          <span>{title}</span>
          <CloseButton onClick={handleClose}>
            <Iconify icon="ic:baseline-close" />
          </CloseButton>
        </Bar>
        {children}
      </Content>
    </ModalPanel>,
    node
  );
};
